import { z } from 'zod';
import { SectionSchema, SectionSchemaZod } from './section.schema.zod';

/** One independently stacked section column owned by a tab or surface slot. */
export interface SectionColumnSchema {
  readonly sections: SectionSchema[];
}

export const SectionColumnSchemaZod: z.ZodType<SectionColumnSchema> = z.object({
  sections: z.array(SectionSchemaZod).min(1),
}).strict();
